import { createStore } from "vuex";
import auth from "./modules/auth";
import users from "./modules/users";
import clients from "./modules/clients";
import paginations from "./modules/paginations";
import products from "./modules/products";
import strykerCommands from "./modules/strykerCommands";
import buyingGroups from "./modules/buyingGroups";
import roles from "./modules/roles";
import franchises from "./modules/franchises";
import franchiseGroups from "./modules/franchiseGroups";
import subFranchises from "./modules/subFranchises";
import gimBrands from "./modules/gimBrands";
import gimItemTypes from "./modules/gimItemTypes";
import gimProductLines from "./modules/gimProductLines";
import gimSubBrands from "./modules/gimSubBrands";
import targetProductGroups from "./modules/targetProductGroups";
import sapgs from "./modules/sapgs";
import statsCustomer from "./modules/statsCustomer";
import gimCustoms from "./modules/gimCustoms";
import sapgCustoms from "./modules/sapgCustoms";
import cart from "./modules/cart";
import addresses from "./modules/addresses";
import ordersOneStryker from "./modules/ordersOneStryker";
import termsAndConditions from "./modules/termsAndConditions";
import priceLists from "./modules/priceLists";
import contracts from "./modules/contracts";
import email from "./modules/email";
import files from "./modules/files";
import kpi from "./modules/kpi";
import statuts from "./modules/statuts";
import pubs from "./modules/pubs";
import pointAdjustments from "./modules/pointAdjustments";
import projections from "./modules/projections";

import upload from "../api/upload";
import exportExcel from "../api/exportExcel";
import fileApi from "../api/files";

export default createStore({
  state: {
    snackbar: {
      model: false,
      text: "",
      color: "",
    },
    linkedFile: [],
    overlay: false,
    loading: false,
    loadingTables: false,
  },
  modules: {
    auth,
    users,
    clients,
    paginations,
    products,
    strykerCommands,
    buyingGroups,
    roles,
    franchises,
    franchiseGroups,
    statsCustomer,
    subFranchises,
    gimBrands,
    gimItemTypes,
    gimProductLines,
    gimSubBrands,
    targetProductGroups,
    sapgs,
    sapgCustoms,
    gimCustoms,
    cart,
    addresses,
    ordersOneStryker,
    termsAndConditions,
    priceLists,
    contracts,
    email,
    files,
    kpi,
    statuts,
    pubs,
    pointAdjustments,
    projections,
  },
  actions: {
    fetchUserAdmin({ dispatch }) {
      return Promise.all([dispatch("roles/fetchAll")]);
    },
    fetchForCustomerUser({ dispatch }, dataToFetch) {
      const data = {
        id: dataToFetch.customerId,
        name: "",
      };
      return Promise.all([
        dispatch("statsCustomer/fetChSpecificStatsCustomer", data),
        dispatch("cart/fetchCartByCustomer", dataToFetch.customerId),
      ]);
    },
    fetchCustomerAdmin({ dispatch }) {
      return Promise.all([
        dispatch("buyingGroups/fetchAll"),
        dispatch("statuts/fetchAll"),
      ]);
    },
    fetchProductAdmin({ dispatch }) {
      return Promise.all([
        dispatch("franchises/fetchAll"),
        dispatch("franchiseGroups/fetchAll"),
        dispatch("subFranchises/fetchAll"),
        dispatch("gimBrands/fetchAll"),
        dispatch("gimItemTypes/fetchAll"),
        dispatch("gimProductLines/fetchAll"),
        dispatch("targetProductGroups/fetchAll"),
        dispatch("sapgs/fetchAll"),
      ]);
    },
    fetchContractAdmin({ dispatch }) {
      return Promise.all([
        dispatch("franchises/fetchAll"),
        dispatch("gimSubBrands/fetchAll"),
      ]);
    },
    fetchContractAdminWithCustomerNumbers({ dispatch }, data) {
      return Promise.all([
        dispatch("franchises/fetchAll"),
        dispatch("gimSubBrands/fetchAll"),
        dispatch("files/getFilesForSpecificContract", data),
      ]);
    },
    showLink({ commit }, link) {
      return fileApi.getFileAvantage(link).then((response) => {
        commit("setLoading", false);
        commit("setLinkedFile", response.data);
        return response;
      });
    },
    exportExcel({ commit }, data) {
      return exportExcel.exportExcel(data).then((response) => {
        commit("setLoading", false);
        return response;
      });
    },
    exportExcelWithQuery({ commit }, data) {
      return exportExcel.exportExcelWithQuery(data).then((response) => {
        commit("setLoading", false);
        return response;
      });
    },
    importFile({ commit }, formData) {
      return upload.import(formData).then((response) => {
        commit("setLoading", false);
        return response;
      });
    },
    showSnackbar({ commit }, payload) {
      commit("showSnackbar", payload);
    },
    hideSnackbar({ commit }) {
      commit("hideSnackbar");
    },
  },
  mutations: {
    showSnackbar(state, { message, color }) {
      state.snackbar.model = true;
      state.snackbar.text = message;
      state.snackbar.color = color;
    },
    hideSnackbar(state) {
      state.snackbar.model = false;
      state.snackbar.text = "";
      state.snackbar.color = "";
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setLoadingTables(state, value) {
      state.loadingTables = value;
    },
    setOverlay(state, value) {
      state.overlay = value;
    },
    setSnackbar(state, value) {
      state.snackbar = value;
    },
    setLinkedFile(state, value) {
      state.linkedFile = value;
    },
  },
});
